<template>
    <v-row>
      <v-col cols="12">
        <v-data-table
          :headers="headers"
          :items="tableItems"
          :loading="loading"
          :loading-text="$t('keywords.loading')"
          :items-per-page.sync="_itemsPerPage_"
          class="elevation-1"
        >
          <template #top>
            <v-toolbar flat color="white">
              <v-toolbar-title v-text="$t('monitoring.all_integrations')" />
              <v-spacer />
              <RefreshButton @click="$emit('refresh')" />
            </v-toolbar>
          </template>
          <template #item.active="{ item }">
            <v-icon
             :color="IntegrationsUtils.getActiveColor(item.active)"
              v-html="IntegrationsUtils.getActiveIcon(item.active)"
            />
          </template>
          <template #item.processType="{ item }">
            <p v-text="$t(IntegrationsUtils.getProcessTypeKey(item.processType))" />
          </template>

          <template #item.lastExecutions="{ item }">
            <LastExecutions v-if="item.lastExecutions" :executions="item.lastExecutions" :processType="item.processType" :integrationID="item.integrationID" />
            <GoToAllIntegrationLogs v-if="item.lastExecutions" :integration="item" />
          </template>

          <template #no-data v-text="$t('warnings.no_data_found')" />
        </v-data-table>
      </v-col>
    </v-row>
</template>
<script>
import IntegrationsUtils from './utils'
import Utils from '../../utils'
import LastExecutions from './LastExecutions/LastExecutions.vue'
import GoToAllIntegrationLogs from './GoToAllIntegrationLogs.vue'
import RefreshButton from '../RefreshButton.vue'

export default {
  name: 'DataTable',

  components: { LastExecutions, GoToAllIntegrationLogs, RefreshButton },

  props: {
    itemsPerPage: Number,
    loading: Boolean,
    items: Array
  },

  data: () => ({
    IntegrationsUtils
  }),

  computed: {
    _itemsPerPage_: {
      get () { return this.itemsPerPage },
      set (v) { this.$emit('update:items-per-page', v) }
    },
    tableItems () {
      return Utils.fillPagination(this.items, this._itemsPerPage_)
        .map(obj => Utils.formatObjectDate(obj, 'lastDate'))
    },
    headers () {
      return [
        /* {
          text: this.$t('check.active'),
          value: 'active',
          sortable: false,
          align: 'center'
        }, */
        {
          text: this.$t('keywords.type'),
          value: 'processType',
          sortable: false,
          align: 'center'
        },
        {
          text: this.$t('keywords.name'),
          value: 'integrationID',
          sortable: false,
          align: 'center'
        },
        {
          text: this.$t('monitoring.last_execution_date'),
          value: 'lastDate',
          sortable: false,
          align: 'center'
        },
        {
          text: this.$t('monitoring.last_executions'),
          value: 'lastExecutions',
          sortable: false,
          align: 'center'
        }
      ]
    }
  }

}
</script>
